var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/BasePopup/BasePopup.jinja"] = require( "front/components/BasePopup/BasePopup.jinja" );
dependencies["front/components/CommonRegions/CommonRegions.jinja"] = require( "front/components/CommonRegions/CommonRegions.jinja" );
dependencies["front/components/ProductionListings/ProductionListings.jinja"] = require( "front/components/ProductionListings/ProductionListings.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/RatesListingsPopup/RatesListingsPopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/RatesListingsPopup/RatesListingsPopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/components/BasePopup/BasePopup.jinja", true, "assets/app/front/pages/RatesListingsPopup/RatesListingsPopup.jinja", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
parentTemplate = t_5
for(var t_4 in parentTemplate.blocks) {
context.addBlock(t_4, parentTemplate.blocks[t_4]);
}
output += "\n\n";
env.getTemplate("front/components/CommonRegions/CommonRegions.jinja", false, "assets/app/front/pages/RatesListingsPopup/RatesListingsPopup.jinja", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(Object.prototype.hasOwnProperty.call(t_7, "CommonRegions")) {
var t_10 = t_7.CommonRegions;
} else {
cb(new Error("cannot import 'CommonRegions'")); return;
}
context.setVariable("CommonRegions", t_10);
output += "\n";
env.getTemplate("front/components/ProductionListings/ProductionListings.jinja", false, "assets/app/front/pages/RatesListingsPopup/RatesListingsPopup.jinja", false, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
t_11.getExported(function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
if(Object.prototype.hasOwnProperty.call(t_11, "ProductionListings")) {
var t_14 = t_11.ProductionListings;
} else {
cb(new Error("cannot import 'ProductionListings'")); return;
}
context.setVariable("ProductionListings", t_14);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupTopLayer"))(env, context, frame, runtime, function(t_16,t_15) {
if(t_16) { cb(t_16); return; }
output += t_15;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupContent"))(env, context, frame, runtime, function(t_18,t_17) {
if(t_18) { cb(t_18); return; }
output += t_17;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupTopLayer(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"BasePopup-print\">\n        ";
output += runtime.suppressValue((lineno = 8, colno = 30, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["popup-print","0 0 40 35",runtime.makeKeywordArgs({"caller": (function (){var macro_t_19 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_20 = "";;
frame = frame.pop();
return new runtime.SafeString(t_20);
});
return macro_t_19;})()})])), env.opts.autoescape);
output += "\n        <div class=\"BasePopup-tip\">Clicking on this icon will allow you to print a simplified version of this page.</div>\n    </div>\n    <a class=\"BasePopup-download u-skipUrlParser\" rel=\"nofollow\" target=\"_blank\" style=\"display: none\">\n        ";
output += runtime.suppressValue((lineno = 12, colno = 30, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["popup-download","0 0 30 40",runtime.makeKeywordArgs({"caller": (function (){var macro_t_21 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_22 = "";;
frame = frame.pop();
return new runtime.SafeString(t_22);
});
return macro_t_21;})()})])), env.opts.autoescape);
output += "\n    </a>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupContent(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"RatesListingsPopup\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"pdf")) {
output += "data-pdf=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"pdf"), env.opts.autoescape);
output += "\"";
;
}
output += ">\n\n        <div class=\"RatesListingsPopup-header\">\n            <div class=\"RatesListingsPopup-title\"><a href=\"";
output += runtime.suppressValue((lineno = 20, colno = 62, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:rates"])), env.opts.autoescape);
output += "\">Rates & Contracts</a></div>\n            <h2 class=\"RatesListingsPopup-caption\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"header")),"title"), env.opts.autoescape);
output += "</h2>\n\n            <div class=\"RatesListingsPopup-wrapperMap\">\n                ";
output += runtime.suppressValue((lineno = 24, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonRegions"), "CommonRegions", context, [runtime.makeKeywordArgs({"data": "","maskSuffix": "ratesListings","needGrid": false,"curRegion": runtime.contextOrFrameLookup(context, frame, "region"),"isPopup": true})])), env.opts.autoescape);
output += "\n            </div>\n\n            <div class=\"RatesListingsPopup-btnWrapper\">\n                <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"area")),"url"), env.opts.autoescape);
output += "\" class=\"RatesListingsPopup-btn\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"area")),"text"), env.opts.autoescape);
output += "</a>\n            </div>\n        </div>\n\n        <div class=\"RatesListingsPopup-listing\">\n            ";
output += runtime.suppressValue((lineno = 33, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ProductionListings"), "ProductionListings", context, [runtime.makeKeywordArgs({"data": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"listing")})])), env.opts.autoescape);
output += "\n        </div>\n\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_popupTopLayer: b_popupTopLayer,
b_popupContent: b_popupContent,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/RatesListingsPopup/RatesListingsPopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/RatesListingsPopup/RatesListingsPopup.jinja
// module id = 546
// module chunks = 0